module.exports = __webpack_public_path__ + "img/5-1_02.01b9b7ab.jpg";